import { Injectable } from '@angular/core';
import { CommonRequestService } from './common-request.service';

import { AppSettings } from 'app/app.settings';

@Injectable()
export class MiscService {

	constructor(
		private requestService: CommonRequestService
	) { }
	sendEmail(email: string, content: string) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/sendEmail';
			const body: any = {
				email: email,
                content: content
			};
			return this.requestService.requestPost(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
}
